import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AppContainer').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'stretch',
    height: '100vh',
    backgroundColor: theme.colors.background.primary,

    padding: '0px',
    margin: '0px',
    overflow: 'auto',

    maxWidth: '600px',
    minWidth: '300px',

    '&:[data-scroll-allowed="true"]': {
      pointerEvents: 'all',
    },
    '&:[data-scroll-allowed="false"]': {
      '* > *:not(#appdrawer):not(#appdrawer *)': {},
    },
  },
}))
